import React from 'react'
import './Experience.css'
import { BsPatchCheckFill } from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>

      <h5> What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>

          <div className="experience_content">
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>

                <h4>HTML5</h4>
                <small className='text-light'>Experienced</small>
              </div>

            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>  <h4>CSS3</h4>
                <small className='text-light'>Experienced</small></div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />


              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>



            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>React</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>React-Redux</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Material UI</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Tailwind CSS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>BootStrap</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>

        <div className="Experience_backend">
          <h3>BackEnd Development</h3>

          <div className="experience_content">
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Node JS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>MongoDB</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Express JS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>MySQL</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Django</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>Python</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>GraphQL</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              < BsPatchCheckFill className='experince_details-icon' />
              <div>
                <h4>AWS & Docker</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>
      </div>

    </section>

  )
}

export default Experience